import React, { Component, ErrorInfo, ReactNode } from "react";
import assets from "./assets";
import { Box, Stack } from "@mui/material";
import Link from "./components/common/Link/Link";

interface Props { children?: ReactNode; }

interface State { hasError: boolean; }

class ErrorBoundary extends Component<Props, State> {

  public state: State = { hasError: false };

  public static getDerivedStateFromError(_: Error): State {

    // Update state so the next render will show the fallback UI.
    return { hasError: true };

  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {

    console.error("Uncaught error:", error, errorInfo);

  }

  public render() {

    if (this.state.hasError) {

      return (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            minHeight: "calc(100vh - 100px)",
            backgroundColor: "white",
            backgroundImage: `url(${assets.images.backgroundImage})`,
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundSize: '780px',
            backgroundPosition: 'right -180px top 180px',
          }}>

          <Stack
            width="100%"
            height="100vh"
            justifyContent="center"
            alignItems="center">

            <Stack
              sx={{
                justifyContent: 'center',
                '& img': {
                  maxWidth: '300px',
                  margin: '0 0 30px 0'
                }
              }}>

              <img src={assets.images.logo} alt="x-series-logo" />

            </Stack>

            <Stack
              direction="column"
              justifyContent="center"
              spacing={2}
              alignItems="center">

              <h1>Sorry we ran into an error...</h1>

              {(process.env.REACT_APP_BASENAME === '/build-your-own' || process.env.REACT_APP_BASENAME === '/dealer-locator')

                ? (<Link hrefText="Click here to return home" href="https://madjax.com" hrefRelative={false} />)

                : (<Link hrefText="Click here to return to login page" href="/login" hrefRelative={true} />)

              }

            </Stack>

          </Stack>

        </Box>

      );

    }

    return this.props.children;

  }

}

export default ErrorBoundary;